import { FC } from "react";
import { ReactComponent as NotesIconSvg } from "../../assets/images/notes-icon.svg";
import { NotesIconWrapper } from "./NotesIcon.style";
import { COMPONENT_IDS } from "../../helpers/constants/componentIds";
import { useNavigationSiteCore } from "../../hooks/useNavigationSiteCore";

type NotesIconProps = {
  onToggleToolTip: () => void;
};

export const NotesIcon: FC<NotesIconProps> = (props: NotesIconProps) => {
  const { commonARIALabel } = useNavigationSiteCore();
  return (
    <NotesIconWrapper
      data-testid={COMPONENT_IDS.ERROR_INFO_ICON}
      onClick={props.onToggleToolTip}
      className="error-info-icon"
      role="button"
      aria-label={commonARIALabel.viewNotes}
    >
      <NotesIconSvg />
    </NotesIconWrapper>
  );
};
